import React, {useEffect} from 'react';
import {observer, useLocalObservable, inject} from "mobx-react";
import {runInAction} from "mobx";
import PropTypes from "prop-types";

function FormField(props) {
  const store = useLocalObservable(() => ({list: [], fetching: false, inited: false}));
  useEffect(() => {
    // mount

    return () => {
      // unmount
    }
  }, []);

  if(props.type === "checkbox") {
    return (
      <div className="up12 splice mbottom15">
        <div className="cell s-shrink s-middle pright5">
          <label>{props.children}<span></span></label>
        </div>
        <div className="cell s-auto s-middle">
          <label htmlFor={props.input_id}>{props.title}</label>
        </div>
        {props.description?(
          <div className="cell s-12 w5 ptop5">
            {props.description}
          </div>
        ):null}
      </div>
    )
  }
  return (
    <div className="mbottom15">
      <div className="pbottom5">{props.title}</div>
      {props.children}
      {props.description?(
        <div className="cell s-12 w5 ptop5">
          {props.description}
        </div>
      ):null}
    </div>
  )

  return (
    <div>
      component
    </div>
  )
};

FormField.defaultProps = {};

FormField.propTypes = {}

export default observer(FormField);
